import { createAction } from "typesafe-actions";
import { AccessActionTypes } from "./types";

export const accessLoaded = createAction(
  AccessActionTypes.ACCESS_LOADED,
  (payload) => payload
)();

export const accessCleared = createAction(
  AccessActionTypes.ACCESS_CLEARED,
  () => {}
)();
